export const strings = {
  en: {
    app_name: "Zenith 360 ERP",
    tagline: "The AI-native finance operating system for India's SMEs.",
    login: "Sign in",
    signup: "Get started",
    email: "Email",
    password: "Password",
    full_name: "Full name",
    org_name: "Business name",
    entity_type: "Entity type",
    proprietorship: "Proprietorship",
    partnership: "Partnership",
    company: "Company",
    llp: "LLP",
    dashboard: "Dashboard",
    support_tickets: "Support Tickets",
    accounts: "Chart of Accounts",
    vouchers: "Vouchers",
    sales: "Sales",
    credit_notes: "Credit Notes",
    debit_notes: "Debit Notes",
    o2c_compliance: "O2C Compliance",
    compliance_calendar: "Compliance Calendar",
    esign: "Aadhaar eSign",
    purchases: "Purchases",
    inventory: "Inventory",
    fixed_assets: "Fixed Assets",
    reports: "Reports",
    registers: "Registers",
    segments: "Segments",
    segment_mis: "Segment P&L",
    mis_pack: "MIS Pack",
    consolidation: "Consolidation",
    advance_tax: "Advance Tax",
    audit: "Audit Trail",
    portal_features: "Feature Toggles",
    templates: "Templates",
    settings: "Settings",
    user_guide: "Feature Guide",
    appearance: "Appearance",
    approvals: "Approvals",
    customers: "Customers",
    vendors: "Vendors",
    ai_assistant: "AI Assistant",
    search_ph: "Search vouchers, invoices, parties, items…  (⌘K)",
    trial_balance: "Trial Balance",
    profit_loss: "Profit & Loss",
    balance_sheet: "Balance Sheet",
    gst_summary: "GST Summary",
    ar_aging: "Receivables Aging",
    ap_aging: "Payables Aging",
    cash_position: "Cash Position",
    receivables: "Receivables",
    payables: "Payables",
    net_profit: "Net Profit",
    gst_liability: "GST Liability",
    new_invoice: "New Invoice",
    new_bill: "New Bill",
    new_voucher: "New Voucher",
    payments: "Payments & Receipts",
    payment_sheet: "Payment Approval Sheet",
    prepaid: "Prepaid Expenses",
    reconcile: "Bank Reconciliation",
    bank_rules: "Bank Rules",
    brs_review: "BRS Review Queue",
    import: "Import Data",
    tds: "TDS & 26AS",
    bom: "BOM / Assembly",
    bom_issue: "BOM · Issue to Shopfloor",
    bom_receive: "BOM · Assembly Receive",
    mfg_masters: "Work-Centers",
    production: "Production",
    mrp: "MRP",
    quality: "Quality · SPC",
    qc_dashboard: "QC Dashboard",
    stores_queue: "Stores Queue",
    gate_inward: "Gate Inward",
    procurement: "Procurement",
    costing: "Costing",
    npd: "NPD · ECO",
    shopfloor: "Shop-Floor Kiosk",
    andon: "Andon TV",
    dealership: "Dealership 360",
    budgets: "Budgets & Forecast",
    recurring: "Recurring Docs",
    msme_report: "MSME Dues",
    fema_realisation: "FEMA · Forex Realisation",
    rule37_reversal: "Rule 37 · ITC Reversal",
    as11_restatement: "AS-11 · Year-End FX",
    working_capital: "Working Capital · CMA",
    fa_simulator: "Fixed Asset · Make/Buy/Hire",
    rcm_register: "RCM Register",
    gst_reports: "GST Reports (Live)",
    compliance_hub: "Compliance Hub",
    gstr6_compliance: "GSTR-6 / 6A",
    gstr9_compliance: "GSTR-9 Annual",
    gstr9c_compliance: "GSTR-9C Recon",
    itc04_compliance: "ITC-04 Job-Work",
    company_gstins: "Company GSTINs",
    approvals: "Approvals",
    ineligible_itc: "Ineligible ITC · Sec 17(5)",
    gstr1: "GSTR-1 · 3-Way Reco",
    ims: "IMS · GSTR-2B Recon",
    gstr3b: "GSTR-3B · Monthly Return",
    gate_pass: "Gate Pass",
    gate_pass_outward: "Gate Pass · Outward",
    gate_pass_inward: "Gate Pass · Inward",
    gate_pass_jobwork: "Gate Pass · Job Work",
    tally_migrator: "Tally Migrator",
    statement_of_account: "Statement of Accounts",
    job_work: "Job Work",
    distribution: "Distribution",
    compliance_hub: "Compliance Management",
    tax_audit: "Tax Audit · 3CA/CB · 3CD",
    corporate_compliance: "Corporate Compliance",
    purchase_return: "Purchase Return",
    itr: "Income Tax Return",
    zoho_migrator: "Zoho Books Migrator",
    migrator_mapper: "Universal Mapper",
    subscription: "Plan & Flows",
    sales_wf: "Quote → SO",
    purchase_wf: "PR → GRN",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    post: "Post",
    reverse: "Reverse",
    lock: "Lock",
    yes: "Yes",
    no: "No",
    total: "Total",
    debit: "Debit",
    credit: "Credit",
    date: "Date",
    number: "Number",
    party: "Party",
    amount: "Amount",
    status: "Status",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    logout: "Log out",
  },
  hi: {
    app_name: "Zenith 360 ERP",
    tagline: "भारत के SMEs के लिए AI-संचालित वित्तीय ऑपरेटिंग सिस्टम।",
    login: "साइन इन",
    signup: "शुरू करें",
    email: "ईमेल",
    password: "पासवर्ड",
    full_name: "पूरा नाम",
    org_name: "व्यापार का नाम",
    entity_type: "इकाई का प्रकार",
    proprietorship: "प्रोप्राइटरशिप",
    partnership: "साझेदारी",
    company: "कंपनी",
    llp: "LLP",
    dashboard: "डैशबोर्ड",
    support_tickets: "सपोर्ट टिकट",
    accounts: "खातों का चार्ट",
    vouchers: "वाउचर",
    sales: "बिक्री",
    purchases: "क्रय",
    inventory: "इन्वेंटरी",
    fixed_assets: "स्थिर संपत्ति",
    reports: "रिपोर्ट्स",
    audit: "ऑडिट ट्रेल",
    templates: "टेम्पलेट",
    settings: "सेटिंग्स",
    approvals: "अनुमोदन",
    customers: "ग्राहक",
    vendors: "विक्रेता",
    ai_assistant: "AI सहायक",
    search_ph: "वाउचर, इनवॉइस, पार्टी, आइटम खोजें… (⌘K)",
    trial_balance: "ट्रायल बैलेंस",
    profit_loss: "लाभ और हानि",
    balance_sheet: "बैलेंस शीट",
    gst_summary: "GST सारांश",
    ar_aging: "प्राप्य आयु",
    ap_aging: "देय आयु",
    cash_position: "नकद स्थिति",
    receivables: "प्राप्य",
    payables: "देय",
    net_profit: "शुद्ध लाभ",
    gst_liability: "GST देयता",
    new_invoice: "नया इनवॉइस",
    new_bill: "नया बिल",
    new_voucher: "नया वाउचर",
    tds: "TDS और 26AS",
    bom: "BOM / असेंबली",
    mfg_masters: "वर्क-सेंटर",
    production: "प्रोडक्शन",
    mrp: "MRP",
    maintenance: "मेंटेनेंस",
    quality: "क्वालिटी · SPC",
    qc_dashboard: "QC डैशबोर्ड",
    stores_queue: "स्टोर्स क्यू",
    gate_inward: "गेट इनवार्ड",
    procurement: "प्रोक्योरमेंट",
    costing: "कॉस्टिंग",
    npd: "NPD · ECO",
    shopfloor: "शॉप-फ्लोर",
    andon: "एंडोन TV",
    dealership: "डीलरशिप 360",
    budgets: "बजट और पूर्वानुमान",
    recurring: "आवर्ती दस्तावेज़",
    msme_report: "MSME बकाया",
    gate_pass: "गेट पास",
    subscription: "प्लान और फ्लो",
    sales_wf: "कोट → SO",
    purchase_wf: "PR → GRN",
    payments: "भुगतान और रसीद",
    reconcile: "बैंक मिलान",
    bank_rules: "बैंक नियम",
    brs_review: "BRS समीक्षा",
    import: "डेटा आयात",
    save: "सहेजें",
    cancel: "रद्द",
    delete: "हटाएँ",
    post: "पोस्ट",
    reverse: "रिवर्स",
    lock: "लॉक",
    yes: "हाँ",
    no: "नहीं",
    total: "कुल",
    debit: "डेबिट",
    credit: "क्रेडिट",
    date: "तारीख",
    number: "नंबर",
    party: "पार्टी",
    amount: "राशि",
    status: "स्थिति",
    actions: "क्रियाएँ",
    add: "जोड़ें",
    edit: "संपादित",
    logout: "लॉग आउट",
  },
};

export const useT = () => {
  const lang = localStorage.getItem("finops_lang") || "en";
  return (key) => strings[lang]?.[key] ?? strings.en[key] ?? key;
};
